<template>
  <AppDialog
    :show="show"
    size="medium"
    position="centered"
    append-to-body
    @close="closeDialog"
  >
    <div class="consent-dialog-title">
      <img
        class="logo"
        height="25"
        :src="logoUrl"
      />
    </div>
    <div class="d-flex flex-column align-items-center">
      <img
        class="d-flex mt-30 mb-10"
        height="102"
        :src="consentImgUrl"
      />
      <div class="corporate-consent-title">Reminder to give notice</div>

      <div class="corporate-consent-text">
        The Silent app is designed to run in the background on company-owned devices. Some states or
        jurisdictions require employers to provide direct notice of electronic monitoring to individual team members. We
        recommend that you notify your employees that electronic monitoring software will be running on their company
        computers.
      </div>
    </div>

    <template #footer>
      <AppButton
        type="primary"
        @click="closeDialog"
      >
        Close
      </AppButton>
    </template>
  </AppDialog>
</template>

<script>
export default {
  name: 'CorporateConsentDialog',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    consentImgUrl: {
      type: String,
      required: true,
    },
    logoUrl: {
      type: String,
      required: true,
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>
